import React from "react";
import { ButtonProps, Button } from "../../../designSystem/button/Button";

export function DownloadActivityIcsButton(props: ButtonProps & { activityId: string }) {

    function downloadIcsFile() {
        fetch(`/api/activities/${props.activityId}/ics`)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${props.activityId}.ics`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    }

    return (
        <Button {...props} onClick={downloadIcsFile} />
    );
}